import { Div } from "../../../../../base/components/native/div";
import { TArticle } from "../../../../../types/article";
import { baseStyle } from "./article-item.style";

export const ArticleItem = (article: TArticle) => {

    let lastPart = article.url.split('/').pop()
    const base = Div(article.title)
    base.el.setAttribute('data-id', article._id)
    base.cssClass(baseStyle)
    base.el.onclick = () => {
        base.emit('select', article)
    }

    return Object.assign(base, {
        getId: () => article._id,
        updateUrl: (url: string) => {
            base.el.innerHTML = url
            article.url = url
        },
    })
}